import React from 'react';
import { MapPin } from 'lucide-react';

interface IRZoneSelectorProps {
  selectedZone: number | null;
  onZoneChange: (zone: number) => void;
  currentIndiceMajore?: number | null;
}

const ZONES_IR = [
  {
    id: 1,
    nom: 'Zone 1',
    taux: '3%',
    description: 'Paris et communes limitrophes',
    couleur: 'bg-blue-100 border-blue-300 text-blue-800'
  },
  {
    id: 2,
    nom: 'Zone 2', 
    taux: '1%',
    description: 'Grandes agglomérations',
    couleur: 'bg-blue-50 border-blue-200 text-blue-700'
  },
  {
    id: 3,
    nom: 'Zone 3',
    taux: '0%',
    description: 'Autres communes',
    couleur: 'bg-gray-50 border-gray-200 text-gray-700'
  }
];

export default function IRZoneSelector({ selectedZone, onZoneChange, currentIndiceMajore }: IRZoneSelectorProps) {
  const calculateIRAmount = (zone: number) => {
    if (!currentIndiceMajore) return 0;
    const traitementAnnuel = (currentIndiceMajore * 5907.34) / 100;
    const taux = zone === 1 ? 0.03 : zone === 2 ? 0.01 : 0.00;
    return Math.round((traitementAnnuel * taux) / 12);
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          <MapPin className="w-4 h-4 inline mr-1" />
          Sélectionnez votre zone géographique
        </label>
        <div className="space-y-2">
          {ZONES_IR.map((zone) => (
            <button
              key={zone.id}
              onClick={() => onZoneChange(zone.id)}
              className={`w-full p-3 rounded-lg border-2 text-left transition-all ${
                selectedZone === zone.id
                  ? `${zone.couleur} ring-2 ring-cyan-200`
                  : 'bg-white border-gray-200 hover:bg-gray-50'
              }`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-medium">{zone.nom} - {zone.taux}</div>
                  <div className="text-xs opacity-75">{zone.description}</div>
                </div>
                {currentIndiceMajore && (
                  <div className="text-sm font-medium">
                    {calculateIRAmount(zone.id).toFixed(2)}€/mois
                  </div>
                )}
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}